import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { classNames } from '@/util/utils';
import FeatureCell from './feature-cell';
import type { ContentForPricingFeatureItem, ContentForPricingPlan } from '@/services/sanity/api/get-pricing-features';
import styles from './feature-line.module.css';
interface FeatureLineProps {
  feature: ContentForPricingFeatureItem;
  plan: ContentForPricingPlan;
  available: boolean;
}
export default function FeatureLine(t0) {
  const $ = _c(17);
  const {
    feature,
    plan,
    available
  } = t0;
  const t1 = !available && styles.unavailable;
  let t2;
  if ($[0] !== t1) {
    t2 = classNames(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== feature.title) {
    t3 = <div>{feature.title}</div>;
    $[2] = feature.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== feature.description) {
    t4 = feature.description && <em><small>{feature.description}</small></em>;
    $[4] = feature.description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== available || $[11] !== feature || $[12] !== plan) {
    t6 = <FeatureCell plan={plan} feature={feature} available={available} />;
    $[10] = available;
    $[11] = feature;
    $[12] = plan;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className={styles.featureLine}>{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}